// Client configuration.
//
// The web app talks to the signaling server on its OWN origin: in dev, Vite
// proxies /api and /ws to the Node server (see vite.config.js); in production,
// nginx proxies them to the Node server on the same domain. This means one origin
// for the whole app, so a single TLS cert (https) covers the API and WebSocket too
// -- which is what makes camera/mic (secure-context only) work over the network.
//
// Set VITE_LUMI_SERVER only when pointing at a server on a DIFFERENT origin.
// ASCII only.

const fromEnv = import.meta.env.VITE_LUMI_SERVER;

export const SERVER_HTTP = (fromEnv || location.origin).replace(/\/$/, '');
export const SERVER_WS = SERVER_HTTP.replace(/^http/, 'ws');
